import { Dimmer, Popup } from './';

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { get, invoke, omit } from 'lodash';

class DimmerPopup extends Component {
  state = { open: false };

  onOpen = () => {
    this.setState({ open: true });
    invoke(this.props, 'onOpen');
  };

  onClose = () => {
    this.setState({ open: false });
    invoke(this.props, 'onClose');
  };

  render() {
    const { trigger } = this.props;
    const props = omit(this.props, 'trigger', 'open', 'onOpen', 'onClose');
    const open = get(this.props, 'open', this.state.open);

    return (
      <Fragment>
        <Dimmer
          active={open}
          //className="nosturi protocol attempt popup"
          inverted
          page
        />
        <Popup
          {...props}
          trigger={trigger}
          open={open}
          onOpen={this.onOpen}
          onClose={this.onClose}
        />
      </Fragment>
    );
  }
}

DimmerPopup.Header = Popup.Header;
DimmerPopup.Content = Popup.Content;

DimmerPopup.propTypes = {
  trigger: PropTypes.element.isRequired,
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
};

export default DimmerPopup;



// WEBPACK FOOTER //
// ./src/components/DimmerPopup.js